// extracted by mini-css-extract-plugin
export default {"tag":"StatusTag_tag__IzZFK"};